class UserAccountService {
  constructor(config, httpDim, localStorageService, customerIntegrationsService) {
    this.config = config;
    this.httpDim = httpDim;
    this.localStorageService = localStorageService;
    this.customerIntegrationsService = customerIntegrationsService;
    this.user = {};
  }

  getUserDetails() {
    let url = this.config.apiRoot + '/userAccount';
    let config = this.config;

    return this.httpDim.get(url, config).then(
      this.onUserDetailsRetrievalSuccess.bind(this),
      this.onUserDetailsRetrievalFailure.bind(this)
    ).then(this.setIntergrationTypes.bind(this));
  }

  setIntergrationTypes() {
    return this.customerIntegrationsService.setIntegrationTypes();
  }

  onUserDetailsRetrievalSuccess(response) {
    angular.copy(response.data.content, this.user);
    this.setUserDetailsInClientStorage();
  }

  onUserDetailsRetrievalFailure() {}

  setSsoUserDetails(content){
    angular.copy(content, this.user);
    this.setUserDetailsInClientStorage();
  }

  setUserDetailsInClientStorage() {
    if (this.user) {
      this.localStorageService.set('user', this.user);
    }
  }

  getUserDetailsFromClientStorage() {
    let user = this.localStorageService.get('user');

    angular.copy(user, this.user);
    return this.user;
  }

  updateUserDetails(user) {
    let url = this.config.apiRoot + '/userAccount';
    let body = user;

    return this.httpDim.put(url, body);
  }

  addAdministrators(admin) {

    let url = this.config.apiRoot + '/userAccount';
    let body = admin;

    return this.httpDim.post(url, body);
  }

  getCustomerAdminDetails(customerId) {
    let url = this.config.apiRoot + '/userAccount?customerId=' + customerId;
    let config = this.config;

    return this.httpDim.get(url, config);
  }

  deactivateCustomerAdmins(userIds) {

    let url = this.config.apiRoot + '/userAccount/' + JSON.stringify(userIds);
    let config = this.config;

    return this.httpDim.delete(url, config);
  }
}

UserAccountService.$inject = ['config', 'httpDim', 'localStorageService', 'customerIntegrationsService'];

export
default UserAccountService;



// WEBPACK FOOTER //
// ./app/common/userAccountService/userAccountService.service.js